import { differenceInHours, differenceInMinutes, differenceInSeconds, endOfDay, parse, subHours } from 'date-fns';

export const TASK_TIME_FORMAT = 'HH:mm:ss.SSSSSSS';
export const TASK_TIME_TABLE_FORMAT = 'HH:mm';

export function convertTimeFromFormat(time: string, formatFrom: string, referenceDate = new Date()): Date {
  return parse(time, formatFrom, referenceDate);
}

export class DateHelper {
  public static get last365days(): Date {
    return new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000);
  }

  public static calculateDurationTillUpdatedOn(updatedOn: Date | string): string {
    const updatedOnDate = updatedOn instanceof Date ? updatedOn : new Date(updatedOn);
    const now = new Date();

    // Calculate differences
    const hoursDifference = differenceInHours(now, updatedOnDate);
    const minutesDifference = differenceInMinutes(now, updatedOnDate) % 60;
    const secondsDifference = differenceInSeconds(now, updatedOnDate) % 60;

    // Calculate the total difference in milliseconds
    const totalDiffMs = now.getTime() - updatedOnDate.getTime();

    // Calculate the milliseconds remainder after subtracting hours, minutes, and seconds
    const usedMs = hoursDifference * 3600000 + minutesDifference * 60000 + secondsDifference * 1000;
    const millisecondsRemainder = totalDiffMs - usedMs;
    const msStr = String(millisecondsRemainder).padStart(3, '0');

    // Check if duration exceeds 24 hours (include days if necessary)
    if (hoursDifference >= 24) {
      const days = Math.floor(hoursDifference / 24);
      const remainingHours = hoursDifference % 24;
      return `${days}.${String(remainingHours).padStart(2, '0')}:${String(minutesDifference).padStart(2, '0')}:${String(secondsDifference).padStart(2, '0')}.${msStr}`;
    } else {
      return `${String(hoursDifference).padStart(2, '0')}:${String(minutesDifference).padStart(2, '0')}:${String(secondsDifference).padStart(2, '0')}.${msStr}`;
    }
  }

  public static get last24hours(): Date {
    return subHours(new Date(), 24);
  }

  public static get endOfToday(): Date {
    return endOfDay(new Date());
  }
}
